export const templatePadaria = {

config:{
cor_primaria:"#6e4b3a"
},

elementos:[

{
id:1,
tipo:"texto",
conteudo:"PADARIA CENTRAL",
pos_x:70,
pos_y:40,
estilo:{fontSize:30,color:"#fff"}
},

{
id:2,
tipo:"texto",
conteudo:"PÃO FRANCÊS",
pos_x:30,
pos_y:180,
estilo:{fontSize:16,color:"#fff"}
},

{
id:3,
tipo:"texto",
conteudo:"R$ 0,80",
pos_x:260,
pos_y:180,
estilo:{fontSize:16,color:"#f1c40f"}
}

]

};